import React from "react";
import { Grid, Typography, Paper } from "@material-ui/core";
import { useAppState } from "../application/AppState";
import useTranslation from "../application/translation";

const Home = () => {
    const [{ customer }] = useAppState();
    const translation = useTranslation();

    if (!customer) return null;

    return (
        <Grid container spacing={3}>
            {/* Customer Info */}
            <Grid item xs={12} md={6}>
                <Paper style={{ padding: '10px' }} elevation={3} component="section" aria-labelledby="customer-info-heading">
                    <Typography id="customer-info-heading" variant="h6">
                        {translation.home_name}
                    </Typography>
                    <Typography variant="body2" aria-label={`Namn: ${customer.firstName} ${customer.lastName}`}>
                        {translation.home_name}: {customer.firstName} {customer.lastName}
                    </Typography>
                    <Typography variant="body2" aria-label={`Personnummer: ${customer.ssn}`}>
                        {translation.home_ssn}: {customer.ssn}
                    </Typography>
                    <Typography variant="body2" aria-label={`E-post: ${customer.email}`}>
                        {translation.home_email}: {customer.email}
                    </Typography>
                </Paper>
            </Grid>

            {/* Optional Right-side panel */}
            <Grid item xs={12} md={6}>
                <Paper elevation={3} style={{ padding: '10px', minHeight: '80px' }}>
                    {/* Optional content can go here */}
                </Paper>
            </Grid>

            {/* Welcome Text */}
            <Grid item xs={12}>
                <Paper style={{ padding: '10px' }} elevation={3}>
                    <Typography variant="body1" aria-label={translation.home_welcomeheader}>
                        {translation.home_welcomeheader}
                    </Typography>
                    <Typography variant="body2" aria-label={translation.home_welcometext}>
                        <br />
                        {translation.home_welcometext}
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Home;
